module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-xs-left"
  }, [_c('h3', {
    staticClass: "modal__title"
  }, [_vm._v(_vm._s(_vm.$t('SEND_ACTIVATION_CODE_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('SEND_ACTIVATION_CODE_2'))), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('SEND_ACTIVATION_CODE_3')) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendCode()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group mb-5"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "validate-danger"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('COMPLETE_FIELDS_CORRECTLY')) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameWoman),
      expression: "nameWoman"
    }],
    staticClass: "col-xs-12 col-sm-6 text-input -white-input-border input",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "nameWoman",
      "placeholder": _vm.$t('FIRST_NAME'),
      "type": "text",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.nameWoman)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameWoman = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "col-xs-12 col-sm-6 text-input -white-input-border input",
    class: {
      validate: _vm.errors.any()
    },
    attrs: {
      "id": "loginEmail",
      "name": "email",
      "placeholder": _vm.$t('EMAIL_ADDRESS'),
      "type": "text",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('CANCEL')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('SEND_2')))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('DATA_ADMINISTRATOR_PURCHASES'))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146dd43e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/send-activating-code.vue
// module id = 1166
// module chunks = 0